jQuery(document).ready(function ($) {
    $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();

// Click function
    $('#tabs-nav li').click(function () {
        $('#tabs-nav li').removeClass('active');
        $(this).addClass('active');
        $('.tab-content').hide();

        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
    });
});

async function fetchData(file) {
    const response = await fetch('https://ammopricesnow.com/ammodata/'+file);
    const data = await response.json();
    return data;
}

async function fetchData2(file) {
    const response = await fetch('https://ammopricesnow.com/ammodata/'+file);
    const data = await response.json();
    return data;
}

function initializeChart(data, dataKey, chartname) {
    // Transform the selected dataset to the format Highcharts needs
    var chartData = data[dataKey].map(function(item) {
        return [Date.parse(item.date), item.price];
    });

    Highcharts.chart('container', {
        title: {
            text: '',
            align: 'left'
        },
        subtitle:{text:"Click and drag to zoom, hold shift and drag to scroll left and right after zooming. On mobile, pinch to zoom and scroll.",align:"center"
        },
        yAxis: {
            title: {
                text: 'Price per round'
            }
        },
        xAxis: {
            type: 'datetime',
            title: {
                text: ''
            },
            tickInterval: 7 * 24 * 3600 * 1000,
            labels: {
                formatter: function() {
                    var date = new Date(this.value);
                    var day = String(date.getDate()).padStart(2, '0');
                    var month = String(date.getMonth() + 1).padStart(2, '0');
                    var year = date.getFullYear();
                    return month + '/' + day + '/' + year;
                },
                rotation: -45
            }
        },
        tooltip: {
            "enabled": true,
            "backgroundColor": "rgba(255,255,255,0.85)",
            "borderWidth": "1",
            "borderColor": "",
            "borderRadius": 3,
            "shared": false,
            "valuePrefix": "$",
            "valueSuffix": ""
        },
        legend: {
            "enabled": true,
            "backgroundColor": "",
            "title": {"text": ""},
            "layout": "horizontal",
            "align": "center",
            "verticalAlign": "bottom",
            "borderWidth": "0",
            "borderColor": "",
            "borderRadius": "0"
        },
        chart: {
            "backgroundColor": "",
            "borderWidth": 0,
            "borderColor": "",
            "borderRadius": 0,
            "zoomType": "x",
            "panning": false,
            "panKey": "shift",
            "plotBackgroundColor": "",
            "plotBackgroundImage": "",
            "plotBorderColor": "",
            "plotBorderWidth": "",
            "inverted": false,
            height: 500
        },
        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false
                },
                pointStart: 2021
            }
        },
        series: [{
            name: chartname,
            color: "#333333",
            data: chartData,
            tooltip: {
                valueDecimals: 2,
                xDateFormat: '%m/%d/%Y'
            }
        }],
        credits: {"enabled": false},
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }]
        }

    });
}

function initializeChart2(data, dataKey, chartname) {
    // Transform the selected dataset to the format Highcharts needs
    var chartData = data[dataKey].map(function(item) {
        return [Date.parse(item.date), item.price];
    });
    Highcharts.chart('container2', {
        title: {
            text: '',
            align: 'left'
        },
        subtitle:{text:"Click and drag to zoom, hold shift and drag to scroll left and right after zooming. On mobile, pinch to zoom and scroll.",align:"center"
        },
        yAxis: {
            title: {
                text: 'Price per round'
            }
        },
        xAxis: {
            type: 'datetime',
            title: {
                text: ''
            },
            tickInterval: 7 * 24 * 3600 * 1000,
            labels: {
                formatter: function() {
                    var date = new Date(this.value);
                    var day = String(date.getDate()).padStart(2, '0');
                    var month = String(date.getMonth() + 1).padStart(2, '0');
                    var year = date.getFullYear();
                    var hours = String(date.getHours()).padStart(2, '0');
                    var minutes = String(date.getMinutes()).padStart(2, '0');
                    return month + '/' + day + '/' + year + ' ' + hours + ':' + minutes;
                },
                rotation: -45
            }
        },
        tooltip: {
            "enabled": true,
            "backgroundColor": "rgba(255,255,255,0.85)",
            "borderWidth": "1",
            "borderColor": "",
            "borderRadius": 3,
            "shared": false,
            "valuePrefix": "$",
            "valueSuffix": ""
        },
        legend: {
            "enabled": true,
            "backgroundColor": "",
            "title": {"text": ""},
            "layout": "horizontal",
            "align": "center",
            "verticalAlign": "bottom",
            "borderWidth": "0",
            "borderColor": "",
            "borderRadius": "0"
        },
        chart: {
            "backgroundColor": "",
            "borderWidth": 0,
            "borderColor": "",
            "borderRadius": 0,
            "zoomType": "x",
            "panning": false,
            "panKey": "shift",
            "plotBackgroundColor": "",
            "plotBackgroundImage": "",
            "plotBorderColor": "",
            "plotBorderWidth": "",
            "inverted": false,
            height: 500
        },
        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false
                },
                pointStart: 2021
            }
        },
        series: [{
            name: chartname,
            color: "#333333",
            data: chartData,
            tooltip: {
                valueDecimals: 2,
                xDateFormat: '%m/%d/%Y'
            }
        }],
        credits: {"enabled": false},
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }]
        }

    });
}

function initializeChart3(data, dataKey) {
    // Transform the selected dataset to the format Highcharts needs
    var chartData = data[dataKey].map(function(item) {
        return {
            name: item.name,
            value: item.value,
            colorValue: item.colorValue
        };
    });

    Highcharts.chart('container3', {
        title: {
            text: '',
            align: 'left'
        },
        subtitle:{text:"Click and drag to zoom, hold shift and drag to scroll left and right after zooming. On mobile, pinch to zoom and scroll.",align:"center"
        },

        "series": [{
            "type": "treemap",
            "layoutAlgorithm": "squarified",
            "name": "Average Price",
            "data": chartData,
            tooltip: {
                valueDecimals: 2
            }
        }],
        "colorAxis": {"minColor": "#FFFFBF", "maxColor": "#006837"},
        "chart": {
            "backgroundColor": "",
            "borderWidth": 0,
            "borderColor": "",
            "borderRadius": 0,
            "zoomType": "none",
            "panning": false,
            "panKey": "shift",
            "plotBackgroundColor": "",
            "plotBackgroundImage": "",
            "plotBorderColor": "",
            "plotBorderWidth": "",
            "inverted": false,
            height: 500
        },
        "yAxis": {"gridLineDashStyle": "solid", "title": {"text": "Price per round"}, "crosshair": false},
        "xAxis": {"crosshair": true},
        "subtitle": {
            "text": "This chart averages prices for each day of the week for the past 2 weeks.",
            "align": "center"
        },
        "tooltip": {
            "enabled": true,
            "backgroundColor": "rgba(255,255,255,0.85)",
            "borderWidth": "1",
            "borderColor": "",
            "borderRadius": 3,
            "shared": false,
            "valuePrefix": "$",
            "valueSuffix": ""
        },
        "legend": {
            "enabled": true,
            "backgroundColor": "",
            "title": {"text": ""},
            "layout": "horizontal",
            "align": "center",
            "verticalAlign": "bottom",
            "borderWidth": "0",
            "borderColor": "",
            "borderRadius": "0"
        },
        credits: {"enabled": false},
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }]
        }

    });
}

function initializeChart4(score){
    Highcharts.chart('fgcontainer', {
        chart: {
            type: 'gauge',
            plotBackgroundColor: null,
            plotBackgroundImage: "",
            plotBorderWidth: 0,
            plotShadow: true,
            height: '80%'
        },
        title: {
            text: null,
            floating: true,
            y: -30
        },
        pane: {
            startAngle: -90,
            endAngle: 90,
            background: null,
            center: ['50%', '50%'],
            size: '90%'
        },
        // the value axis
        yAxis: {
            min: 0,
            max: 100,
            tickPixelInterval: 72,
            tickPosition: 'inside',
            tickColor: '#fff',
            tickLength: 30,
            tickWidth: 2,
            minorTickInterval: null,
            labels: {
                distance: 20,
                style: {
                    fontSize: '14px'
                }
            },
            lineWidth: 0,
            plotBands: [{
                from: 0,
                to: 50,
                color: '#55BF3B', // green
                thickness: 30
            }, {
                from: 80,
                to: 100,
                color: '#DF5353', // red
                thickness: 30
            }, {
                from: 50,
                to: 80,
                color: '#DDDF0D', // yellow
                thickness: 30
            }]
        },
        credits: {"enabled": false},
        series: [{
            name: 'Score',
            data: [score],
            tooltip: {
                valueSuffix: ''
            },
            dataLabels: {
                y: 25,
                format: '<span style="font-size:40px;margin-top:20px;display:block;"><br />{y}</span>',
                borderWidth: 0,
                color:'#333333',
                style: {
                    fontSize: '16px'
                }
            },
            dial: {
                radius: '80%',
                backgroundColor: '#f47541',
                baseWidth: 30,
                baseLength: '10%',
                rearLength: '5%'
            },
            pivot: {
                backgroundColor: 'black',
                radius: 11
            }

        }]

    });
}

function initializeChart5(data, dataKey, chartname) {
    // Transform the selected dataset to the format Highcharts needs
    var chartData = data[dataKey].map(function(item) {
        return [Date.parse(item.date), item.score];
    });

    Highcharts.stockChart('containerfg', {
        title: {
            text: '',
            align: 'left'
        },
        subtitle:{text:"",align:"center"
        },
        yAxis: {
            title: {
                text: 'Ammo Price Index Over Time'
            },
            opposite:false,
            min: 0,
            max: 100,
        },
        xAxis: {
            type: 'datetime',
            title: {
                text: ''
            },
            tickInterval: 2,
            labels: {
                formatter: function() {
                    var date = new Date(this.value);
                    var day = String(date.getDate()).padStart(2, '0');
                    var month = String(date.getMonth() + 1).padStart(2, '0');
                    var year = date.getFullYear();
                    return month + '/' + day + '/' + year;
                },
                overflow:false,
                padding: 10,
                rotation: -45
            }
        },
        tooltip: {
            "enabled": true,
            "backgroundColor": "rgba(255,255,255,0.85)",
            "borderWidth": "1",
            "borderColor": "",
            "borderRadius": 3,
            "shared": false,
            "valuePrefix": "",
            "valueSuffix": ""
        },
        legend: {
            "enabled": true,
            "backgroundColor": "",
            "title": {"text": ""},
            "layout": "horizontal",
            "align": "center",
            "verticalAlign": "bottom",
            "borderWidth": "0",
            "borderColor": "",
            "borderRadius": "0"
        },
        chart: {
            "backgroundColor": "",
            "borderWidth": 0,
            "borderColor": "",
            "borderRadius": 0,
            "zoomType": "x",
            "panning": false,
            "panKey": "shift",
            "plotBackgroundColor": "",
            "plotBackgroundImage": "",
            "plotBorderColor": "",
            "plotBorderWidth": "",
            "inverted": false,
            height: 500
        },
        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false
                },
            }
        },
        series: [{
            name: chartname,
            color: "#333333",
            data: chartData,
            tooltip: {
                valueDecimals: 2,
                xDateFormat: '%m/%d/%Y'
            }
        }],
        credits: {"enabled": false},
        rangeSelector: {
            inputEnabled : false,
            buttons: [{
                type: 'month',
                count: 1,
                text: '1m',
            }, {
                type: 'month',
                count: 3,
                text: '3m'
            }, {
                type: 'month',
                count: 6,
                text: '6m'
            }, {
                type: 'year',
                count: 1,
                text: '1y'
            }],
            selected: 1
        },
        navigator: {
            enabled: false
        },
        scrollbar: {
            enabled: false
        },
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }]
        }
    });
}